import { render, staticRenderFns } from "./BureauList.vue?vue&type=template&id=1294f96a&scoped=true"
import script from "./BureauList.vue?vue&type=script&lang=js"
export * from "./BureauList.vue?vue&type=script&lang=js"
import style0 from "./BureauList.vue?vue&type=style&index=0&id=1294f96a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1294f96a",
  null
  
)

export default component.exports